export interface Formation {
  id: number;
  id_formation_bitrix: number;
  name: string;
  order: number;
  is_default: boolean;
  commercial_name: string;
  duration: string;
  formation_type: 'ACCELERATED' | 'CERTIFYING' | 'DIPLOMA' | null;
  has_cpf: boolean;
  is_eligible_alternance: boolean;
}

export interface Theme {
  id: number;
  name: string;
  order: number;
  is_visible_in_form_lead: boolean;
  formations: Formation[];
}

export const findFormation = ({
  themes,
  id,
}: {
  themes: Theme[];
  id: number;
}): Formation | null =>
  themes
    .flatMap((theme) => theme.formations ?? [])
    .find((formation) => formation.id_formation_bitrix === id) ?? null;

export const getDomainFormations = ({
  themes,
  domainId,
}: {
  themes: Theme[];
  domainId: number;
}): Formation[] => {
  const formations =
    themes.find((theme) => theme.id === domainId)?.formations ?? [];
  return formations.toSorted((a, b) => a.order - b.order);
};

export const getDefaultFormation = ({
  themes,
  domainId,
}: {
  themes: Theme[];
  domainId: number;
}): Formation | undefined =>
  getDomainFormations({ themes, domainId }).find(
    (formation) => formation.is_default,
  );
